import request from "@/utils/request";
import { chatInstance } from "@/utils/request";

//获取我发布的线索
export const myClueList = (params) => {
  return request.get("/api/mts-api/clue/myClueList", { params });
};
//获取线索详情
export const myClueDetails = (params) => {
  return request.get("/api/mts-api/clue/" + params + "");
};
//查询我的货品
export const mySaleGoodsList = (params) => {
  return request.get("/api/mts-api/goods/mySaleGoodsList", { params, headers: { "Accept-Language": "en-US" } });
};
//查询我提交的订购单
export const myPreOrderList = (params) => {
  return request.get("/api/mts-api/preOrder/myPreOrderList", { params });
};
//订购单详情
export const myreOrderDetails = (params) => {
  return request.get("/api/mts-api/preOrder/detail", { params });
};

//获取我的交易订单
export const myOrderList = (params) => {
  return request.get("/api/mts-api/order/myOrderList", { params });
};

//获取我的验货商品列表
export const myYanHuoGoodsList = (params) => {
  return request.get("/api/mts-api/mtsGoods/myYanHuoGoodsList", { params });
};

//获取待商务接单的订购单（出售、购买）
// export const pendingSWFollowPreOrderList = (params) => {
//   return request.get('/api/mts-api/preOrder/pendingSWFollowPreOrderList', { params })
// }
//实名认证
export const userauthn = (data) => {
  return request.post("/api/mts-api/user/authn", data);
};
//获取导航
export const getNavList = (params) => {
  return request.get("/api/mts-api/nav/list", { params });
};
//申请成为谈判人接口
export const getShopApply = (params) => {
  return request.post("/api/mts-api/shop/apply", params);
};

//根据字典type获取字典值列表
export const getByType = (params) => {
  return request.get("/api/mts-api/dict/getByType/" + params);
};

// 获取类型管理列表
export const getGoodsType = (params) => {
  return request.get("/api/mts-api/goods/type/search", { params });
};

// 获取合同管理列表
export const myContracts = (params) => {
  return request.get("/api/mts-api/contract/review/getMyRecord", { params });
};

// 获取合同管理列表
export const myContractDetail = ({ contractId, preOrderId, reviewType }) => {
  return request({
    url: "/api/mts-api/order/getOrderList",
    params: { contractId, preOrderId, reviewType },
    method: "get",
  });
};

export const auditContract = (params) => {
  return request.post("/api/mts-api/contract/review/update", params);
};

export const renewsContract = (params) => {
  return request.post("/api/mts-api/order/renewsContract", params);
};

// 更新合同（上传合同文件）
export const updateContract = (params) => {
  return request.post("/api/mts-api/contract/update", params);
};

// 更新合同补充数据（外币模板草稿等，不走合同文件上传校验）
export const updateContractSupplement = (params) => {
  return request.post("/api/mts-api/contract/updateSupplement", params);
};

// 客户实际打开/下载单章合同后，标记合同已被客户查看
export const markContractCustomerViewed = (params) => {
  return request.post("/api/mts-api/contract/markCustomerViewed", params);
};

// 获取店铺详情
export const getShopDetail = (params) => {
  return request.get("/api/mts-api/shop/getShopDetail", { params });
};

// 获取店铺商品列表
export const getShopGoodsList = (params) => {
  return request.get("/api/mts-api/shop/getShopGoodsList", { params });
};

// 获取店铺信息列表
export const getShopClueList = (params) => {
  return request.get("/api/mts-api/shop/getShopClueList", { params });
};

// 发起付款审批（可能修改收款方信息）
export const paymentApply = (params) => {
  return request.post("/api/mts-api/contract/paymentApply", params);
};

// 标记已读
export const markAsRead = (sessionId, userId) => {
  return request.put(`/api/mts-api/chat/markAsRead/${sessionId}/${userId}`);
};

/** 由当前登录参与者删除双方的完整旧聊天会话。 */
export const deleteLegacyChatConversation = (sessionId) => {
  return request.delete(`/api/mts-api/chat/session/${sessionId}`);
};

// 显示用户列表
export const getChatUsers = (userId) => {
  return request.get(`/api/mts-api/chat/chatUsers/${userId}`);
};

// 查询历史聊天记录
export const getChatMessages = (sessionId, params) => {
  return request.get(`/api/mts-api/chat/messages/${encodeURIComponent(sessionId)}`, { params });
};

// 发送消息
export const sendChatMessage = (data) => {
  return request.post("/api/mts-api/chat/sendMessage", data);
};

// 轮询查询未读消息
export const getUnreadMessages = (userId) => {
  return request.get(`/api/mts-api/chat/unread/${userId}`);
};

// 获取分期付款信息
export const getInstallments = (params) => {
  return request.get("/api/mts-api/order/getInstallments", { params });
};
